import { PAYOUT_REQUESTS_GRID_NAME } from '../../constants';

import { actionLoadPayoutRequestsRequest } from '../../actions/payoutRequestsGrid';

import {
  ACTION_CANCEL_PAYOUT_REQUEST__REQUEST,
  ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS,
  ACTION_CANCEL_PAYOUT_REQUEST__FAIL,
} from '../../actionTypes';

import { getGridSaga } from 'react-redux-app/lib/modules/grid/sagas';


export default getGridSaga(
  PAYOUT_REQUESTS_GRID_NAME,
  actionLoadPayoutRequestsRequest,
  [ACTION_CANCEL_PAYOUT_REQUEST__REQUEST],
  [ACTION_CANCEL_PAYOUT_REQUEST__FAIL],
  [ACTION_CANCEL_PAYOUT_REQUEST__SUCCESS]
);
